import { render } from "./DropdownContent.vue?vue&type=template&id=275f0ab4"
import script from "./DropdownContent.vue?vue&type=script&lang=js"
export * from "./DropdownContent.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__